import { preventDefault } from "@frui.ts/views";
import Button from "@edaz/edazkit/Button/index";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay/index";
import { observer } from "mobx-react-lite";
import React from "react";
import { Form } from "react-bootstrap";
import type DetailViewModel from "viewModels/detailViewModel";
import type { IEditableViewModel } from "../../viewModels/types";
import { IconType } from "@edaz/edazkit/Icon";

export interface DetailViewProps<TEntity> {
  vm: DetailViewModel<TEntity> | IEditableViewModel<TEntity>;
  form: React.ReactElement;
  titleInfo?: React.ReactElement;
  customBackButtonText?: string;
}

function DetailView<TEntity>(props: DetailViewProps<TEntity>) {
  const { vm, form, titleInfo, customBackButtonText } = props;

  return (
    <LoaderOverlay loading={vm.busyWatcher.isBusy}>
      <div>
        <a className="link" style={{ position: "absolute", cursor: "pointer" }} onClick={vm.cancel}>
          <Button iconLeft={IconType.ArrowLeft} variant="danger" className="mr-3" />
          {customBackButtonText ? customBackButtonText : vm.translateGeneral("cancel")}
        </a>
        <div className="d-flex flex-column align-items-center justify-content-center">
          <h3 className="mb-1 text-center">{vm.translate("detail")}</h3>
          {titleInfo}
        </div>
      </div>
      {/* eslint-disable-next-line @typescript-eslint/no-empty-function */}
      <Form onSubmit={preventDefault(() => {})}>{form}</Form>
    </LoaderOverlay>
  );
}

export default observer(DetailView);
